var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepublicOfTheCongo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53514)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67364 30.2277L20.4277 20.4272L30.2282 8.67315C28.7044 5.72016 26.2883 3.30272 23.3365 1.77704L11.5731 11.5727L1.77759 23.3359C3.30315 26.2879 5.72058 28.7039 8.67364 30.2277V30.2277Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3139 27.3141C32.3618 22.2661 33.3309 14.6851 30.2231 8.66345L8.66333 30.2232C14.685 33.3309 22.2661 32.3619 27.3139 27.3141Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68557 4.68569C-0.362293 9.73356 -1.33129 17.3147 1.77639 23.3363L23.3362 1.77657C17.3145 -1.33124 9.73344 -0.362113 4.68557 4.68569V4.68569Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepublicOfTheCongo);
export default __webpack_public_path__ + "static/media/republic-of-the-congo.cb2d30bc.svg";
export { ForwardRef as ReactComponent };